import { formatMoney } from '../../util/currency';

/**
 * Formats an intermediate USD amount without repeating the currency symbol.
 */
const formatIntermediateMoney = (intl, money) => formatMoney(intl, money).replace('$', '');

export default formatIntermediateMoney;
